module.exports = __webpack_public_path__ + "static/media/grey-cross.d54ca119.svg";